(() => {
    "use strict";

    const SCROLLED_CLASS = "site-header-scrolled";
    const THRESHOLD = 32;

    function syncHeaderScroll() {
        document.body.classList.toggle(SCROLLED_CLASS, window.scrollY > THRESHOLD);
    }

    window.siteReady(() => {
        syncHeaderScroll();
        window.addEventListener("scroll", syncHeaderScroll, { passive: true });
    });
})();
